/**
 * OrdenesCompra Feature
 */

export * from './graphql/ordenes-compra.queries';
export * from './models/ordenes-compra.models';
export * from './models/oc.model';
export * from './services/ordenes-compra.service';
